import React from 'react';
import PropTypes from 'prop-types';
import styles from './MatrixHeader.scss';
import { subscriptionTypes } from 'rp-auth';

const { TIPPING, ULTIMATE, INSIGHTS } = subscriptionTypes;
function MatrixHeader({ service, services }) {
  return (
    <div className={`${styles.root} ${styles[service]}`}>
      <h3 className={styles.subscriptionTitle}>{services[service].title}</h3>
      <div className={styles.subscriptionDescription}>{services[service].description}</div>
    </div>
  );
}

MatrixHeader.propTypes = {
  service: PropTypes.string.isRequired,
  services: PropTypes.shape({
    essential: PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
MatrixHeader.defaultProps = {
  services: {
    insights: {
      title: INSIGHTS,
      description:
                'The in-the-know one. Unlimited access to our cards, insights, statistics and race analysis',
    },
    tipping: {
      title: TIPPING,
      description:
                'The cut-to-the-chase one. The hottest tips from Tom Segal, Paul Kealy, Steve Palmer and more',
    },
    ultimate: {
      title: ULTIMATE,
      description:
                'The expert one. Full access to tipping, insights and all of our award-winning journalism',
    },
  },
};
export default MatrixHeader;
